/* GOLF SAVED MY LIFE — theme interactions + Shopify cart */
(function () {
  'use strict';
  var root = document.documentElement;

  /* ---- Theme toggle (defaults to system, persists on device) ---- */
  var toggle = document.querySelector('[data-theme-toggle]');
  var theme;
  try { theme = localStorage.getItem('gsml-theme'); } catch (e) {}
  if (!theme) theme = (window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
  root.setAttribute('data-theme', theme);
  function syncToggle() {
    if (!toggle) return;
    toggle.setAttribute('aria-label', 'Switch to ' + (theme === 'dark' ? 'light' : 'dark') + ' mode');
  }
  syncToggle();
  if (toggle) {
    toggle.addEventListener('click', function () {
      theme = (theme === 'dark') ? 'light' : 'dark';
      root.setAttribute('data-theme', theme);
      try { localStorage.setItem('gsml-theme', theme); } catch (e) {}
      syncToggle();
    });
  }

  /* ---- Scroll-aware header ---- */
  var header = document.getElementById('header');
  var lastY = 0, ticking = false;
  function onScroll() {
    var y = window.scrollY;
    if (!header) return;
    if (y > 24) header.classList.add('header--scrolled'); else header.classList.remove('header--scrolled');
    if (y > lastY && y > 160) header.classList.add('header--hidden'); else header.classList.remove('header--hidden');
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });

  /* ---- Mobile nav toggle ---- */
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.getElementById('mobileNav');
  if (navToggle && mobileNav) {
    function setMenu(open) {
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('nav-open', open);
    }
    navToggle.addEventListener('click', function () { setMenu(navToggle.getAttribute('aria-expanded') !== 'true'); });
    mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }

  /* ---- Marquee pause on hover ---- */
  var marquee = document.querySelector('.marquee__track');
  if (marquee) {
    var parent = marquee.closest('.marquee');
    parent.addEventListener('mouseenter', function () { marquee.style.animationPlayState = 'paused'; });
    parent.addEventListener('mouseleave', function () { marquee.style.animationPlayState = 'running'; });
  }

  /* ---- Reveal on scroll ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.product-card, .collection-card, .feature__panel, .editorial__panel, .manifesto__body, .manifesto__lede');
  if (!reduce && 'IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach(function (el) {
      el.style.opacity = '0'; el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.style.opacity = '1'; entry.target.style.transform = 'translateY(0)'; io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     SHOPIFY CART — AJAX drawer
     ============================================================ */
  var FREE_SHIP = parseInt(window.GSML && window.GSML.freeShippingThreshold, 10) || 0;
  var body = document.body;
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer__overlay');
  var badge = document.querySelector('.cart-count');

  function money(cents) {
    if (window.GSML && window.GSML.moneyFormat) return window.GSML.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    return '$' + (cents / 100).toFixed(2);
  }
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); body.classList.add('drawer-open'); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); body.classList.remove('drawer-open'); }
  window.GSML = window.GSML || {};
  window.GSML.openCart = openDrawer; window.GSML.closeCart = closeDrawer;

  function renderCart(cart) {
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count ? '' : 'none'; }
    var items = drawer && drawer.querySelector('.cart-drawer__items');
    var subtotal = drawer && drawer.querySelector('.cart-drawer__subtotal');
    var empty = drawer && drawer.querySelector('.cart-drawer__empty');
    var footer = drawer && drawer.querySelector('.cart-drawer__footer');
    var bar = drawer && drawer.querySelector('.cart-drawer__progress');
    if (cart.item_count === 0) {
      if (items) items.innerHTML = '';
      if (empty) empty.style.display = '';
      if (footer) footer.style.display = 'none';
    } else {
      if (empty) empty.style.display = 'none';
      if (footer) footer.style.display = '';
      if (subtotal) subtotal.textContent = money(cart.total_price);
      if (items) {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_120x140$1') : '';
          return '<div class="cart-line" data-line="' + it.line + '">' +
            '<a href="' + it.url + '" class="cart-line__img"><img src="' + img + '" alt=""></a>' +
            '<div class="cart-line__body">' +
              '<a href="' + it.url + '" class="cart-line__title">' + it.product_title + '</a>' +
              (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="cart-line__variant mono-label">' + it.variant_title + '</span>' : '') +
              '<div class="cart-line__row"><div class="qty">' +
                '<button type="button" class="qty__btn" data-qty-change="-1" aria-label="Decrease quantity">–</button>' +
                '<span class="qty__val">' + it.quantity + '</span>' +
                '<button type="button" class="qty__btn" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div><span class="cart-line__price">' + money(it.final_line_price) + '</span></div>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-remove-line aria-label="Remove">×</button>' +
          '</div>';
        }).join('');
      }
    }
    if (bar && FREE_SHIP > 0) {
      var remain = Math.max(0, FREE_SHIP * 100 - cart.total_price);
      var pct = Math.min(100, Math.round((cart.total_price / (FREE_SHIP * 100)) * 100));
      var fill = drawer.querySelector('.cart-drawer__bar-fill');
      var txt = drawer.querySelector('.cart-drawer__bar-text');
      if (fill) fill.style.width = pct + '%';
      if (txt) txt.textContent = remain > 0 ? 'You\u2019re ' + money(remain) + ' from free shipping' : 'You\u2019ve unlocked free shipping';
    }
  }
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(renderCart); }

  // Add to cart (delegate all product forms)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.dataset.adding = '1'; btn.innerHTML = 'Adding\u2026'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { if (btn) { btn.innerHTML = 'Added'; } openDrawer(); document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: fd.get('id'), qty: fd.get('quantity') } })); setTimeout(function () { if (btn && !btn.disabled) { btn.innerHTML = orig; } }, 1200); })
      .catch(function () { if (btn) { btn.innerHTML = 'Try again'; btn.disabled = false; } });
  });

  // Line item changes
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line]');
    if (!line) return;
    var lineNo = parseInt(line.getAttribute('data-line'), 10);
    var qtyBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-remove-line]');
    if (qtyBtn) { var dir = parseInt(qtyBtn.getAttribute('data-qty-change'), 10); var val = parseInt(line.querySelector('.qty__val').textContent, 10) || 1; changeLine(lineNo, Math.max(0, val + dir)); }
    else if (removeBtn) { changeLine(lineNo, 0); }
  });
  function changeLine(line, quantity) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  // Open/close
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  refresh();
})();
